import { render, staticRenderFns } from "./SubcontractorLabourAgreementCard.vue?vue&type=template&id=27457306"
import script from "./SubcontractorLabourAgreementCard.vue?vue&type=script&lang=ts"
export * from "./SubcontractorLabourAgreementCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports